import React from "react";
import Modal from "../masters/Modal";

const ESTABLISHMENT_OPTIONS = [
  { id: "shops_establishment", label: "Shops & Establishment" },
  { id: "factory", label: "Factory" },
];

export default function StatutoryProfileModal({
  isOpen,
  onClose,
  profileDraft,
  setProfileDraft,
  employees,
  onSave,
}) {
  const inputClass =
    "h-9 w-full rounded-md border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-2 text-xs";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCancel={onClose}
      onSubmit={onSave}
      submitText="Save profile"
      title="Establishment profile"
      maxWidthClass="max-w-3xl"
    >
      <p className="ds-caption mb-3 text-[hsl(var(--ds-muted-fg))]">
        Printed on statutory form headers. Controls Shops vs Factory registers.
      </p>
      <div className="mb-3 flex flex-wrap gap-4">
        {ESTABLISHMENT_OPTIONS.map((opt) => (
          <label key={opt.id} className="flex items-center gap-2 text-xs">
            <input
              type="checkbox"
              checked={profileDraft.establishmentTypes.includes(opt.id)}
              onChange={(e) => {
                setProfileDraft((prev) => {
                  const set = new Set(prev.establishmentTypes);
                  if (e.target.checked) set.add(opt.id);
                  else set.delete(opt.id);
                  return { ...prev, establishmentTypes: [...set] };
                });
              }}
            />
            {opt.label}
          </label>
        ))}
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        <input className={inputClass} placeholder="Establishment name" value={profileDraft.establishmentName} onChange={(e) => setProfileDraft((p) => ({ ...p, establishmentName: e.target.value }))} />
        <input className={inputClass} placeholder="Establishment address" value={profileDraft.establishmentAddress} onChange={(e) => setProfileDraft((p) => ({ ...p, establishmentAddress: e.target.value }))} />
        <select className={inputClass} value={profileDraft.responsiblePersonEmployeeId} onChange={(e) => setProfileDraft((p) => ({ ...p, responsiblePersonEmployeeId: e.target.value }))}>
          <option value="">Responsible person (employee)</option>
          {employees.map((emp) => (
            <option key={emp.id} value={emp.id}>
              {emp.empCode} — {[emp.user?.name, emp.user?.lastName].filter(Boolean).join(" ")}
            </option>
          ))}
        </select>
        <input className={inputClass} placeholder="Owner name" value={profileDraft.ownerName} onChange={(e) => setProfileDraft((p) => ({ ...p, ownerName: e.target.value }))} />
        <input className={inputClass} placeholder="Shops registration no." value={profileDraft.shopsRegistrationNo} onChange={(e) => setProfileDraft((p) => ({ ...p, shopsRegistrationNo: e.target.value }))} />
        <input className={inputClass} placeholder="Factory licence no." value={profileDraft.factoryLicenseNo} onChange={(e) => setProfileDraft((p) => ({ ...p, factoryLicenseNo: e.target.value }))} />
        <input className={inputClass} placeholder="PF establishment code" value={profileDraft.pfEstablishmentCode} onChange={(e) => setProfileDraft((p) => ({ ...p, pfEstablishmentCode: e.target.value }))} />
        <input className={inputClass} placeholder="ESI employer code" value={profileDraft.esiEmployerCode} onChange={(e) => setProfileDraft((p) => ({ ...p, esiEmployerCode: e.target.value }))} />
        <input className={inputClass} placeholder="LIN number" value={profileDraft.linNumber} onChange={(e) => setProfileDraft((p) => ({ ...p, linNumber: e.target.value }))} />
        <input className={inputClass} placeholder="Contractor name" value={profileDraft.contractorName} onChange={(e) => setProfileDraft((p) => ({ ...p, contractorName: e.target.value }))} />
        <input className={inputClass} placeholder="Contractor address" value={profileDraft.contractorAddress} onChange={(e) => setProfileDraft((p) => ({ ...p, contractorAddress: e.target.value }))} />
        <input className={inputClass} placeholder="Principal employer name" value={profileDraft.principalEmployerName} onChange={(e) => setProfileDraft((p) => ({ ...p, principalEmployerName: e.target.value }))} />
        <input className={inputClass} placeholder="Principal employer address" value={profileDraft.principalEmployerAddress} onChange={(e) => setProfileDraft((p) => ({ ...p, principalEmployerAddress: e.target.value }))} />
        <input className={inputClass} placeholder="Nature & location of work" value={profileDraft.natureAndLocationOfWork} onChange={(e) => setProfileDraft((p) => ({ ...p, natureAndLocationOfWork: e.target.value }))} />
        <input className={inputClass} placeholder="Statutory PF rate (%)" value={profileDraft.statutoryPfRate} onChange={(e) => setProfileDraft((p) => ({ ...p, statutoryPfRate: e.target.value }))} />
      </div>
    </Modal>
  );
}
